<template>
  <div class="inclusion-scale d-flex">
    <div class="dots my-auto d-flex ga-1">
      <div
        v-for="i in [0, 1, 2, 3, 4]"
        :key="i"
        class="dot"
        :class="[{ active: score > i }, `score-${Math.ceil(score)}`]"
      />
    </div>

    <div class="ml-2 text-textLight text-body-3">
      {{ scoreText }}
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  value: {
    type: Number,
    required: true,
  },
  hideColor: {
    type: Boolean,
    default: false,
  },
});

const score = computed(() => (5 - props.value) || 0);
const scoreText = computed(() => [
  '',
  'Exclusive',
  'Fairly Exclusive',
  'Somewhat Exclusive',
  'Fairly Inclusive',
  'Inclusive',
][score.value]);
</script>

<style lang="less" scoped>
.dots {
  .dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: @grey-500;

    &.active {
      &.score-1 {
        background-color: @red-500;
      }
      &.score-2 {
        background-color: @red-500;
      }
      &.score-3 {
        background-color: @orange-500;
      }
      &.score-4 {
        background-color: @green-500;
      }
      &.score-5 {
        background-color: @green-500;
      }
    }
  }
}
</style>
